import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Browser, SsrService } from '@interticket/core';
import { fromEvent, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-custom-sidebar',
  templateUrl: './custom-sidebar.component.html',
  styleUrls: ['./custom-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomSidebarComponent implements OnDestroy {

  private readonly destroy$ = new Subject<void>();

  private _isOpen = false;

  constructor(
    private ssrService: SsrService
  ) { }

  @Input()
  set isOpen(isOpen: boolean) {
    if (!!isOpen !== this._isOpen) {
      this._isOpen = isOpen;
      this.updateHistory(!!isOpen);

      if (isOpen) {
        this.closeOnNextBackNavigation();
      }
    }
  }

  get isOpen(): boolean {
    return this._isOpen;
  }

  @Output() readonly onClose = new EventEmitter();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private isOpenInHistory(): boolean {
    return this.ssrService.history.state?.sidebarOpen;
  }

  private closeOnNextBackNavigation(): void {
    fromEvent(window, 'popstate')
      .pipe(
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.onClose.emit();
      });
  }

  @Browser()
  private updateHistory(isOpen: boolean): void {
    if (isOpen && !this.isOpenInHistory()) {
      this.ssrService.history.pushState({ sidebarOpen: true }, this.ssrService.document.title);

    } else if (!isOpen && this.isOpenInHistory()) {
      this.ssrService.history.back();
    }
  }

}
